import type { FC } from 'react';

interface LeadsRegistryLeadCardSkeletonProps {
  isCompact: boolean;
}

const renderBlock = (className: string) => (
  <span className={`LeadsRegistryCards__skeleton-block ${className}`} />
);

export const LeadsRegistryLeadCardSkeleton: FC<
  LeadsRegistryLeadCardSkeletonProps
> = ({ isCompact }) => (
  <div
    className="LeadsRegistryCards__card LeadsRegistryCards__card--skeleton"
    aria-hidden="true"
  >
    <div className="LeadsRegistryCards__card-head">
      <div className="LeadsRegistryCards__identity">
        {renderBlock('LeadsRegistryCards__skeleton-avatar')}
        <div className="LeadsRegistryCards__identity-text">
          {renderBlock(
            'LeadsRegistryCards__skeleton-line LeadsRegistryCards__skeleton-line--title'
          )}
          {renderBlock(
            'LeadsRegistryCards__skeleton-line LeadsRegistryCards__skeleton-line--subtitle'
          )}
        </div>
      </div>
      {renderBlock('LeadsRegistryCards__skeleton-badge')}
    </div>

    {renderBlock(
      'LeadsRegistryCards__skeleton-line LeadsRegistryCards__skeleton-line--message'
    )}

    {isCompact ? (
      renderBlock(
        'LeadsRegistryCards__skeleton-line LeadsRegistryCards__skeleton-line--compact-meta'
      )
    ) : (
      <div className="LeadsRegistryCards__meta-grid">
        {renderBlock(
          'LeadsRegistryCards__skeleton-line LeadsRegistryCards__skeleton-line--meta'
        )}
        {renderBlock(
          'LeadsRegistryCards__skeleton-line LeadsRegistryCards__skeleton-line--meta'
        )}
        {renderBlock(
          'LeadsRegistryCards__skeleton-line LeadsRegistryCards__skeleton-line--meta-short'
        )}
      </div>
    )}

    <div className="LeadsRegistryCards__tag-row">
      {renderBlock('LeadsRegistryCards__skeleton-tag')}
      {!isCompact && renderBlock('LeadsRegistryCards__skeleton-tag')}
      {renderBlock('LeadsRegistryCards__skeleton-more')}
    </div>
  </div>
);
